import { Chart, ChartArea, ChartXAxis, ChartXAxisItem, ChartLegend, ChartSeries, ChartSeriesItem, ChartTitle, ChartTooltip, RenderEvent, SeriesVisualArgs, MarkersVisualArgs } from "@progress/kendo-react-charts";
import { Switch } from "@progress/kendo-react-inputs";
import { ExpansionPanel, ExpansionPanelContent } from "@progress/kendo-react-layout";
import "hammerjs";
import { Fragment, useCallback, useEffect, useState } from "react";
import SweetAlertService from "../../../services/SweetAlertService";
import ReportService from "../Services/ReportService";
import { AppConstants } from "../Shared/Constants/AppConstant";
import { academicMarkerVisual } from "./ReportUtils";

export const OverView = (props: any) => {
    //To initialize values for toggel
    const [isExcludeLeaveToggelChecked, setIsExcludeLeaveToggelChecked] = useState<any>(false);
    const [isExcludePublicHolidayToggelChecked, setIsExcludePublicHolidayToggelChecked] = useState<any>(false);
    const [isPublicHolidayExistInPeriod, setIsPublicHolidayExistInPeriod] = useState<any>(false);
    const [isPublicHolidayExistsInAllWeeks, setIsPublicHolidayExistsInAllWeeks] = useState<any>(false);
    const [isLeaveExistInPeriod, setIsLeaveExistInPeriod] = useState<any>(false);
    const [isLeaveExistsInAllWeeks, setIsLeaveExistsInAllWeeks] = useState<any>(false);
    const [showErrorMessageForLeaveToggle, setShowErrorMessageForLeaveToggle] = useState<any>(false);
    const [showErrorMessageForPublicHolidayToggle, setShowErrorMessageForPublicHolidayToggle] = useState<any>(false);

    //To initialize values for line chart
    const [weekRange, setWeekRange] = useState<any>([]);
    const [lineChartCategories, setLineChartCategories] = useState<any>([]);

    //For donut chart
    const [clickedSegment, setClickedSegment] = useState<any>({ name: "", totalHours: 0, totalMinutes: 0, id: 0 });
    const [expanded, setExpanded] = useState<any>();

    //For category
    const [donutChartByCategories, setDonutChartByCategories] = useState<any>([]);
    const [donutChartByCategoriesCopy, setDonutChartByCategoriesCopy] = useState<any>([]);

    //For sub-category
    const [donutChartBySubCategories, setDonutChartBySubCategories] = useState<any>([]);
    const [donutChartBySubCategoriesCopy, setDonutChartBySubCategoriesCopy] = useState<any>([]);

    //For total minutes
    const [totalHours, setTotalHours] = useState<any>();

    //For total hours
    const [totalMinutes, setTotalMinutes] = useState<any>();

    //For total weeks
    const [totalNumberOfWeeks, setTotalNumberOfWeeks] = useState<any>();

    //For total sessions
    const [totalSessions, setTotalSessions] = useState<any>();

    //Overview response
    const [overViewResponse, setOverViewResponse] = useState<any>();

    //To set subcatgories
    let subCategoriesToSetForDefaultValue: any = [];

    //To get category color for donut chart 
    const getColorForCategory = (category: any, subCategoriesList: any) => {

        let subcategories = subCategoriesList.filter((x: { categoryId: any; }) => x.categoryId == category.id);
        let total = 10 / subcategories.length;

        subcategories.forEach((element: any, index: any) => {
            let opacity = (total * (subcategories.length - index)) / 10;
            element.color = getColorForSubCategory(element, opacity);
            element.totalDurationMinutes = (element.totalHours * 60) + element.totalMinutes;
            subCategoriesToSetForDefaultValue.push(element);
        });

        let map: any = {
            [AppConstants.DCC_Category_Id]: '#0967B1',
            [AppConstants.ICC_Category_Id]: '#DA1F6C',
            [AppConstants.Non_Clinical_Work_Category_Id]: '#008E82',
            [AppConstants.Training_And_Supervision_Category_Id]: '#6F4F9B',
            [AppConstants.CPD_Category_Id]: '#EA580D',
            [AppConstants.Academic_Category_Id]: '#000000',
        };

        if (category.isUserDefined) {
            return '#76A227';
        } else {
            return map[category.id];
        }
    }

    //To get sub-category color for donut chart 
    const getColorForSubCategory = (element: any, opacity: any) => {
        let alpha = opacity - 0.1;
        let map: any = {
            [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,' + alpha + ')',
            [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,' + alpha + ')',
            [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,' + alpha + ')',
            [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,' + alpha + ')',
            [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,' + alpha + ')',
            [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,' + alpha + ')',
        };

        if (element.isUserDefined) {
            return 'rgba(118, 162, 39,' + alpha + ')';
        } else {
            return map[element.categoryId];
        }
    }

    //To set chart data
    const setChartData = (donutChartByCategories: any, donutChartBySubCategories: any, totalHours: any, totalMinutes: any, totalNumberOfWeeks: any, totalSessions: any, lineChartCategories: any, isPublicHolidayToggle: any, isLeaveToggle: any, weekRangeData: any) => {
        subCategoriesToSetForDefaultValue = [];
        donutChartByCategories.map((element: any) => {
            element.color = getColorForCategory(element, donutChartBySubCategories);
            element.totalDurationMinutes = (element.totalHours * 60) + element.totalMinutes;
        });
        setDonutChartByCategories(donutChartByCategories);
        setDonutChartByCategoriesCopy(JSON.parse(JSON.stringify(donutChartByCategories)));
        setDonutChartBySubCategories(donutChartBySubCategories);
        setDonutChartBySubCategoriesCopy(JSON.parse(JSON.stringify(subCategoriesToSetForDefaultValue)));
        setTotalHours(totalHours);
        setTotalMinutes(totalMinutes);
        setTotalNumberOfWeeks(totalNumberOfWeeks);
        setTotalSessions(totalSessions);
        setLineChartCategories(lineChartCategories);
        const expand: any = donutChartByCategories.reduce(
            (acc: any, cur: any) => ({ ...acc, [cur.id]: true }),
            {}
        );
        setExpanded({ ...expand });
        //For report pdf
        props.setOverViewData({ categories: JSON.parse(JSON.stringify(donutChartByCategories)), subCategories: JSON.parse(JSON.stringify(donutChartBySubCategories)), totalHours: totalHours, totalMinutes: totalMinutes, totalNumberOfWeeks: totalNumberOfWeeks, lineChartData: lineChartCategories, isPublicHolidayToggelChecked: isPublicHolidayToggle, isLeaveToggelChecked: isLeaveToggle, weekRange: weekRangeData });
    }

    useEffect(() => {
        getOverviewDetails();
    }, []);

    //categories for no data
    const weekWithNoCategoriesData = [
        { id: 1, name: "", totalHours: 0, totalMinutes: 0, color: "rgb(191,191,191)", totalSessions: 0, totalDurationMinutes: 100, percentage: 0, isUserDefined: false }
    ];
    //sub-categories for no data
    const weekWithNoSubCategoriesData = [
        { id: 1, categoryId: AppConstants.DCC_Category_Id, name: "", categoryName: "", color: "rgb(191,191,191)", totalHours: 0, totalMinutes: 0, totalSessions: 0, totalDurationMinutes: 50, percentage: 0, isUserDefined: false },
        { id: 2, categoryId: AppConstants.DCC_Category_Id, name: "", categoryName: "", color: "rgb(191,191,191)", totalHours: 0, totalMinutes: 0, totalSessions: 0, totalDurationMinutes: 50, percentage: 0, isUserDefined: false },
    ];

    //To build data for chart
    const BuildChartForNoDataFound = (donutChartByCategories: any, totalNumberOfWeeks: any, lineChartCategories: any, isPublicHolidayToggle: any, isLeaveToggle: any, weekRangeData: any) => {
        setTotalNumberOfWeeks(totalNumberOfWeeks);
        setLineChartCategories(lineChartCategories);
        setDonutChartByCategories(weekWithNoCategoriesData);
        setDonutChartByCategoriesCopy(JSON.parse(JSON.stringify(weekWithNoCategoriesData)));
        setDonutChartBySubCategories(weekWithNoSubCategoriesData);
        setDonutChartBySubCategoriesCopy(JSON.parse(JSON.stringify(weekWithNoSubCategoriesData)));
        setTotalHours(0);
        setTotalMinutes(0);
        const expand: any = donutChartByCategories.reduce(
            (acc: any, cur: any) => ({ ...acc, [cur.id]: true }),
            {}
        );
        setExpanded({ ...expand });
        props.setOverViewData({ categories: weekWithNoCategoriesData, subCategories: weekWithNoSubCategoriesData, totalHours: 0, totalMinutes: 0, totalNumberOfWeeks: totalNumberOfWeeks, lineChartData: lineChartCategories, isPublicHolidayToggelChecked: isPublicHolidayToggle, isLeaveToggelChecked: isLeaveToggle, weekRange: weekRangeData });
    }

    //Set orginal data
    const setAllData = (overViewData: any, lineChartData: any, isPublicHolidayToggle: any, isLeaveToggle: any, weekRangeData: any) => {
        if (overViewData.overViewCatgories.length > 0) {
            setChartData(overViewData.overViewCatgories, overViewData.overViewSubCatgories, overViewData.totalHours, overViewData.totalMinutes, overViewData.totalNumberOfWeeks, overViewData.totalSessions, lineChartData, isPublicHolidayToggle, isLeaveToggle, weekRangeData);
        } else {
            //When no data exists
            BuildChartForNoDataFound(overViewData.overViewCatgories, overViewData.totalNumberOfWeeks, lineChartData, isPublicHolidayToggle, isLeaveToggle, weekRangeData);
        }
    }

    //To get over view details
    const getOverviewDetails = () => {
        let payload: any = {};
        payload.startDate = new Date(props.startDate.getFullYear(), props.startDate.getMonth(), props.startDate.getDate(), 0, 0, 0);
        payload.endDate = new Date(props.endDate.getFullYear(), props.endDate.getMonth(), props.endDate.getDate(), 23, 59, 59);
        payload.employerID = props.employerID;
        ReportService.getOverviewDetails(payload).then((response: any) => {
            if (response) {
                var overViewData = response.data.overViewDonutChartDto;
                // To set values related to line chart
                setWeekRange(response.data.overViewLineChartDto.xAxisRange);
                setOverViewResponse(response.data);
                let weekRangeData = response.data.overViewLineChartDto.xAxisRange;
                //When leave and public holiday exists in all week  
                if (overViewData.isLeaveExistsInAllWeeks && overViewData.isPublicHolidayExistsInAllWeeks) {
                    setIsLeaveExistsInAllWeeks(true);
                    setIsPublicHolidayExistsInAllWeeks(true);
                    setAllData(overViewData, response.data.overViewLineChartDto.lineChartCategoryDto, false, false, weekRangeData);
                }
                //When leave exists in all week 
                else if (overViewData.isLeaveExistsInAllWeeks) {
                    setIsLeaveExistsInAllWeeks(true);
                    //When public holiday exists 
                    if (overViewData.isPublicHolidayExistInPeriod) {
                        setIsPublicHolidayExistInPeriod(true);
                        setIsExcludePublicHolidayToggelChecked(true);
                        if (overViewData.overViewExcludingPublicHolidaysCatgories.length > 0) {
                            setChartData(overViewData.overViewExcludingPublicHolidaysCatgories, overViewData.overViewExcludingPublicHolidaysSubCatgories, overViewData.totalHoursExcludingPublicHolidays, overViewData.totalMinutesExcludingPublicHolidays, overViewData.totalNumberOfWeeksExcludingPublicHoliday, overViewData.totalSessionsExcludingPublicHolidays, response.data.overViewLineChartDto.lineChartExcludinPublicHolidayCategoryDto, true, false, weekRangeData)
                        } else {
                            //When no data exists
                            BuildChartForNoDataFound(overViewData.overViewExcludingPublicHolidaysCatgories, overViewData.totalNumberOfWeeksExcludingPublicHoliday, response.data.overViewLineChartDto.lineChartExcludinPublicHolidayCategoryDto, true, false, weekRangeData);
                        }
                    } else {
                        setAllData(overViewData, response.data.overViewLineChartDto.lineChartCategoryDto, false, false, weekRangeData);
                    }
                    //When public holiday exists in all week
                } else if (overViewData.isPublicHolidayExistsInAllWeeks) {
                    setIsPublicHolidayExistsInAllWeeks(true);
                    if (overViewData.isLeaveExistInPeriod) {
                        setIsExcludeLeaveToggelChecked(true);
                        setIsLeaveExistInPeriod(true);
                        if (overViewData.overViewExcludingLeaveCatgories.length > 0) {
                            setChartData(overViewData.overViewExcludingLeaveCatgories, overViewData.overViewExcludingLeaveSubCatgories, overViewData.totalHoursExcludingLeaves, overViewData.totalMinutesExcludingLeaves, overViewData.totalNumberOfWeeksExcludingLeave, overViewData.totalSessionsExcludingLeaves, response.data.overViewLineChartDto.lineChartExcludinLeaveCategoryDto, false, true, weekRangeData)
                        } else {
                            //When no data exists
                            BuildChartForNoDataFound(overViewData.overViewExcludingLeaveCatgories, overViewData.totalNumberOfWeeksExcludingLeave, response.data.overViewLineChartDto.lineChartExcludinLeaveCategoryDto, false, true, weekRangeData);
                        }
                    } else {
                        setAllData(overViewData, response.data.overViewLineChartDto.lineChartCategoryDto, false, false, weekRangeData);
                    }
                }
                if (!overViewData.isLeaveExistsInAllWeeks && !overViewData.isPublicHolidayExistsInAllWeeks) {
                    //When public holiday and leave exists 
                    if (overViewData.isLeaveExistInPeriod && overViewData.isPublicHolidayExistInPeriod) {
                        setIsExcludeLeaveToggelChecked(true);
                        setIsExcludePublicHolidayToggelChecked(true);
                        setIsLeaveExistInPeriod(true);
                        setIsPublicHolidayExistInPeriod(true);
                        if (overViewData.overViewExcludingLeaveAndPublicHolidaysCatgories.length > 0) {
                            setChartData(overViewData.overViewExcludingLeaveAndPublicHolidaysCatgories, overViewData.overViewExcludingLeaveAndPublicHolidaysSubCatgories, overViewData.totalHoursExcludingLeavesAndPublicHoliday, overViewData.totalMinutesExcludingLeavesAndPublicHoliday, overViewData.totalNumberOfWeeksExcludingLeaveAndPublicHoliday, overViewData.totalSessionsExcludingLeavesAndPublicHoliday, response.data.overViewLineChartDto.lineChartExcludingLeaveAndPublicHolidaysCategoryDto, true, true, weekRangeData);
                        } else {
                            //When no data exists
                            BuildChartForNoDataFound(overViewData.overViewExcludingLeaveAndPublicHolidaysCatgories, overViewData.totalNumberOfWeeksExcludingLeaveAndPublicHoliday, response.data.overViewLineChartDto.lineChartExcludingLeaveAndPublicHolidaysCategoryDto, true, true, weekRangeData);
                        }
                    }
                    //When public leave exists 
                    else if (overViewData.isLeaveExistInPeriod) {
                        setIsExcludeLeaveToggelChecked(true);
                        setIsLeaveExistInPeriod(true);
                        if (overViewData.overViewExcludingLeaveCatgories.length > 0) {
                            setChartData(overViewData.overViewExcludingLeaveCatgories, overViewData.overViewExcludingLeaveSubCatgories, overViewData.totalHoursExcludingLeaves, overViewData.totalMinutesExcludingLeaves, overViewData.totalNumberOfWeeksExcludingLeave, overViewData.totalSessionsExcludingLeaves, response.data.overViewLineChartDto.lineChartExcludinLeaveCategoryDto, false, true, weekRangeData)
                        } else {
                            //When no data exists
                            BuildChartForNoDataFound(overViewData.overViewExcludingLeaveCatgories, overViewData.totalNumberOfWeeksExcludingLeave, response.data.overViewLineChartDto.lineChartExcludinLeaveCategoryDto, false, true, weekRangeData);
                        }
                    }
                    //When public holiday exists 
                    else if (overViewData.isPublicHolidayExistInPeriod) {
                        setIsExcludePublicHolidayToggelChecked(true);
                        setIsPublicHolidayExistInPeriod(true);
                        if (overViewData.overViewExcludingPublicHolidaysCatgories.length > 0) {
                            setChartData(overViewData.overViewExcludingPublicHolidaysCatgories, overViewData.overViewExcludingPublicHolidaysSubCatgories, overViewData.totalHoursExcludingPublicHolidays, overViewData.totalMinutesExcludingPublicHolidays, overViewData.totalNumberOfWeeksExcludingPublicHoliday, overViewData.totalSessionsExcludingPublicHolidays, response.data.overViewLineChartDto.lineChartExcludinPublicHolidayCategoryDto, true, false, weekRangeData)
                        } else {
                            //When no data exists
                            BuildChartForNoDataFound(overViewData.overViewExcludingPublicHolidaysCatgories, overViewData.totalNumberOfWeeksExcludingPublicHoliday, response.data.overViewLineChartDto.lineChartExcludinPublicHolidayCategoryDto, true, false, weekRangeData);
                        }
                    }
                    else {
                        setAllData(overViewData, response.data.overViewLineChartDto.lineChartCategoryDto, false, false, weekRangeData);
                    }
                }
            }
        })
            .catch((error: any) => {
                console.log(error);
                SweetAlertService.error("Error", "Something went wrong while loading overview chart");
            });
    }

    //To set legends
    const onAction = useCallback(
        (id: any) => {
            setExpanded({ ...expanded, [id]: !expanded[id] });
        },
        [expanded]
    );

    //To show the center of donut chart
    const donutCenterRenderer = () => {
        return (
            <span className="fs-5">
                {clickedSegment?.name ? (
                    <div>
                        <h5 className="text-dark fs-5">{clickedSegment.totalHours}h {clickedSegment.totalMinutes < 10 ? '0' : '' + clickedSegment.totalMinutes.toString()}m</h5>
                        <h5 className="text-dark fs-5">{clickedSegment.name}</h5>
                    </div>
                ) :
                    (
                        <div>
                            <h2 className="text-dark fs-5">{totalHours}h {totalMinutes < 10 ? '0' : '' + totalMinutes}m</h2>
                        </div>
                    )
                }
            </span>
        )
    }

    //To show the the tooltip onclick and onhover the donut chart
    const renderTooltip = (context: any) => {
        if (totalHours > 0 || totalMinutes > 0) {
            const { category, series } = context.point || context;
            const dataItem = series.data.find((item: any) => item.name === category);
            return (
                <div>
                    <p className="mb-1"> {category}</p>
                    <p className="mb-1">{dataItem.totalSessions.toFixed(2)} sessions</p>
                    <p className="mb-1"> {dataItem.totalHours?.toFixed(0)}h {dataItem.totalMinutes?.toFixed(0)}m</p>
                    <p className="mb-1"> {dataItem.percentage.toFixed(1)}%</p>
                </div>);
        }
    };

    //To get original colour for sub-categories in donut chart
    const getSubCategoryOriginalColor = (subCategoryId: any) => {
        let ele = donutChartBySubCategoriesCopy.filter((x: { id: any; }) => x.id == subCategoryId)[0];
        return ele?.color;
    }

    //method to click any category or sub-catgory in donut chart
    const handleOnClick = (event: any) => {
        if (totalHours > 0 || totalMinutes > 0) {
            const { category, series } = event.point;
            let categoryId = event.series.name == "categories" ? event.dataItem.id : event.dataItem.categoryId;

            let map: any = {
                [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,0.2)',
                [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,0.2)',
                [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,0.2)',
                [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,0.2)',
                [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,0.2)',
                [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,0.2)',
            };

            let mapO: any = {
                [AppConstants.DCC_Category_Id]: '#0967B1',
                [AppConstants.ICC_Category_Id]: '#DA1F6C',
                [AppConstants.Non_Clinical_Work_Category_Id]: '#008E82',
                [AppConstants.Training_And_Supervision_Category_Id]: '#6F4F9B',
                [AppConstants.CPD_Category_Id]: '#EA580D',
                [AppConstants.Academic_Category_Id]: '#000000',
            };

            donutChartByCategories.forEach((element: any) => {
                if (element.id != categoryId) {
                    element.color = element.isUserDefined ? 'rgba(118, 162, 39, 0.2)' : map[element.id];
                } else {
                    element.color = element.isUserDefined ? '#76A227' : mapO[element.id];
                }
            });

            let alpha = 0.2;

            let mapSubCategory: any = {
                [AppConstants.DCC_Category_Id]: 'rgba(137, 207, 240,' + alpha + ')',
                [AppConstants.ICC_Category_Id]: 'rgba(218, 31, 108,' + alpha + ')',
                [AppConstants.Non_Clinical_Work_Category_Id]: 'rgba(0, 142, 130,' + alpha + ')',
                [AppConstants.Training_And_Supervision_Category_Id]: 'rgba(111, 79, 155,' + alpha + ')',
                [AppConstants.CPD_Category_Id]: 'rgba(234, 88, 13,' + alpha + ')',
                [AppConstants.Academic_Category_Id]: 'rgba(0, 0, 0,' + alpha + ')',
            };

            donutChartBySubCategories.forEach((element: any) => {
                if (element.categoryId != categoryId) {
                    element.color = element.isUserDefined ? 'rgba(118, 162, 39,' + alpha + ')' : mapSubCategory[element.categoryId]
                } else {
                    element.color = getSubCategoryOriginalColor(element.id);
                }
            });

            const clickedDataItem = series.data.find((item: any) => item.name === category);
            if (clickedDataItem) {
                // Set the clicked segment's data
                setClickedSegment({
                    name: clickedDataItem.name,
                    totalHours: clickedDataItem.totalHours,
                    totalMinutes: clickedDataItem.totalMinutes,
                    id: clickedDataItem.id,
                });
            }
            setDonutChartByCategories(donutChartByCategories);
            setDonutChartBySubCategories(donutChartBySubCategories);
        }
    }

    //To reset the chart on click of outer of donut chart
    const reset = () => {
        if (totalHours > 0 || totalMinutes > 0) {
            setDonutChartByCategories(JSON.parse(JSON.stringify(donutChartByCategoriesCopy)));
            setDonutChartBySubCategories(JSON.parse(JSON.stringify(donutChartBySubCategoriesCopy)));
            setClickedSegment({});
        }
    }

    //method to call on-hover on catgory or sub-catgory in donut chart
    const handleOnHover = (event: any) => {
        event.point.options.highlight.visible = false;
    }

    // To get color for line chart
    const getColorForLineChart = (item: any) => {
        let map = new Map<number, string>();
        map.set(AppConstants.DCC_Category_Id, '#0967B1');
        map.set(AppConstants.ICC_Category_Id, '#DA1F6C');
        map.set(AppConstants.Non_Clinical_Work_Category_Id, '#008E82');
        map.set(AppConstants.Training_And_Supervision_Category_Id, '#6F4F9B');
        map.set(AppConstants.CPD_Category_Id, '#EA580D');
        map.set(AppConstants.Employer_Contract_Hours_Category_Id, 'grey');
        map.set(AppConstants.Total_Worked_Category_Id, '#FFDF00');
        map.set(AppConstants.Academic_Category_Id, '#000000');

        if (item.isUserDefined) {
            return '#76A227'
        } else {
            return map.get(item.categoryId);
        }
    }

    //To map the catgories for line chart
    const mapSeries = (item: any, index: any) => {
        return (
            <ChartSeriesItem key={index} data={item.totalWorkedHours} type="scatterLine"
                color={getColorForLineChart(item)}
                width={(item.categoryId === AppConstants.Total_Worked_Category_Id) || (item.categoryId === AppConstants.Employer_Contract_Hours_Category_Id) ? 2 : 1}
                dashType={(item.categoryId === AppConstants.DCC_Category_Id || item.categoryId === AppConstants.Training_And_Supervision_Category_Id || item.isUserDefined || item.categoryId === AppConstants.Academic_Category_Id) ? 'dash' : 'solid'}
                highlight={
                    item.categoryId === AppConstants.Academic_Category_Id
                        ? { visible: false }
                        : undefined
                }
                markers={{
                    size: ((item.categoryId === AppConstants.DCC_Category_Id || item.categoryId === AppConstants.Total_Worked_Category_Id || item.categoryId === AppConstants.Employer_Contract_Hours_Category_Id) ? 24 :
                        (item.categoryId === AppConstants.ICC_Category_Id || item.categoryId === AppConstants.Training_And_Supervision_Category_Id) ? 15 :
                            (item.categoryId === AppConstants.CPD_Category_Id || item.isUserDefined) ? 9 :
                                (item.categoryId === AppConstants.Non_Clinical_Work_Category_Id || item.categoryId === AppConstants.Academic_Category_Id) ? 30 : 24),
                    type: ((item.categoryId === AppConstants.DCC_Category_Id || item.categoryId === AppConstants.Total_Worked_Category_Id || item.categoryId === AppConstants.Employer_Contract_Hours_Category_Id) ? 'circle' :
                        (item.categoryId === AppConstants.ICC_Category_Id || item.categoryId === AppConstants.Training_And_Supervision_Category_Id) ? 'square' :
                            (item.categoryId === AppConstants.CPD_Category_Id || item.isUserDefined) ? 'triangle' :
                                (item.categoryId === AppConstants.Non_Clinical_Work_Category_Id) ? 'cross' : 'circle'),
                    visible: totalNumberOfWeeks == 1 ? true : (item.categoryId === AppConstants.Employer_Contract_Hours_Category_Id) ? false : true,
                    background: "none",
                    visual: item.categoryId === AppConstants.Academic_Category_Id ? academicMarkerVisual : undefined,
                }}
            />
        );
    }

    //To reset all the values of chart
    const resetChartData = () => {
        setDonutChartByCategories([]);
        setDonutChartByCategoriesCopy([]);
        setDonutChartBySubCategories([]);
        setDonutChartBySubCategoriesCopy([]);
        setTotalHours(0);
        setTotalMinutes(0);
        setTotalNumberOfWeeks(0);
        setTotalSessions(0);
        setLineChartCategories([]);
        setExpanded({});
        setClickedSegment({});
    }

    //To call method when user change the values of Public holiday toggele
    const onExcludePublicHolidayChange = (event: any) => {
        if (isPublicHolidayExistsInAllWeeks) {
            setShowErrorMessageForPublicHolidayToggle(true);
        }
        else {
            reset();
            resetChartData();
            setShowErrorMessageForLeaveToggle(false);
            setIsExcludePublicHolidayToggelChecked(event.value);
            let overViewDonutData = overViewResponse.overViewDonutChartDto;
            let overViewLineChartData = overViewResponse.overViewLineChartDto;

            //When public holiday and leave exists 
            if (event.value && isExcludeLeaveToggelChecked) {
                if (overViewDonutData.overViewExcludingLeaveAndPublicHolidaysCatgories.length > 0) {
                    setChartData(overViewDonutData.overViewExcludingLeaveAndPublicHolidaysCatgories, overViewDonutData.overViewExcludingLeaveAndPublicHolidaysSubCatgories, overViewDonutData.totalHoursExcludingLeavesAndPublicHoliday, overViewDonutData.totalMinutesExcludingLeavesAndPublicHoliday, overViewDonutData.totalNumberOfWeeksExcludingLeaveAndPublicHoliday, overViewDonutData.totalSessionsExcludingLeavesAndPublicHoliday, overViewLineChartData.lineChartExcludingLeaveAndPublicHolidaysCategoryDto, true, true, weekRange);
                } else {
                    //When no data exists
                    BuildChartForNoDataFound(overViewDonutData.overViewExcludingLeaveAndPublicHolidaysCatgories, overViewDonutData.totalNumberOfWeeksExcludingLeaveAndPublicHoliday, overViewLineChartData.lineChartExcludingLeaveAndPublicHolidaysCategoryDto, true, true, weekRange);
                }
            }
            //When public holiday exists 
            else if (event.value) {
                if (overViewDonutData.overViewExcludingPublicHolidaysCatgories.length > 0) {
                    setChartData(overViewDonutData.overViewExcludingPublicHolidaysCatgories, overViewDonutData.overViewExcludingPublicHolidaysSubCatgories, overViewDonutData.totalHoursExcludingPublicHolidays, overViewDonutData.totalMinutesExcludingPublicHolidays, overViewDonutData.totalNumberOfWeeksExcludingPublicHoliday, overViewDonutData.totalSessionsExcludingPublicHolidays, overViewLineChartData.lineChartExcludinPublicHolidayCategoryDto, true, false, weekRange)
                } else {
                    //When no data exists
                    BuildChartForNoDataFound(overViewDonutData.overViewExcludingPublicHolidaysCatgories, overViewDonutData.totalNumberOfWeeksExcludingPublicHoliday, overViewLineChartData.lineChartExcludinPublicHolidayCategoryDto, true, false, weekRange);
                }
            }
            //When leave exists 
            else if (isExcludeLeaveToggelChecked) {
                if (overViewDonutData.overViewExcludingLeaveCatgories.length > 0) {
                    setChartData(overViewDonutData.overViewExcludingLeaveCatgories, overViewDonutData.overViewExcludingLeaveSubCatgories, overViewDonutData.totalHoursExcludingLeaves, overViewDonutData.totalMinutesExcludingLeaves, overViewDonutData.totalNumberOfWeeksExcludingLeave, overViewDonutData.totalSessionsExcludingLeaves, overViewLineChartData.lineChartExcludinLeaveCategoryDto, false, true, weekRange)
                } else {
                    //When no data exists
                    BuildChartForNoDataFound(overViewDonutData.overViewExcludingLeaveCatgories, overViewDonutData.totalNumberOfWeeksExcludingLeave, overViewLineChartData.lineChartExcludinLeaveCategoryDto, false, true, weekRange);
                }
            } else {
                setAllData(overViewDonutData, overViewLineChartData.lineChartCategoryDto, false, false, weekRange);
            }
        }
    }

    //To call method when user change the values of Leave toggele
    const onExcludeLeaveChange = (event: any) => {
        if (isLeaveExistsInAllWeeks) {
            setShowErrorMessageForLeaveToggle(true);
        }
        else {
            reset();
            resetChartData();
            setShowErrorMessageForPublicHolidayToggle(false);
            let overViewDonutData = overViewResponse.overViewDonutChartDto;
            let overViewLineChartData = overViewResponse.overViewLineChartDto;
            setIsExcludeLeaveToggelChecked(event.value);
            //When public holiday and leave exists 
            if (event.value && isExcludePublicHolidayToggelChecked) {
                if (overViewDonutData.overViewExcludingLeaveAndPublicHolidaysCatgories.length > 0) {
                    setChartData(overViewDonutData.overViewExcludingLeaveAndPublicHolidaysCatgories, overViewDonutData.overViewExcludingLeaveAndPublicHolidaysSubCatgories, overViewDonutData.totalHoursExcludingLeavesAndPublicHoliday, overViewDonutData.totalMinutesExcludingLeavesAndPublicHoliday, overViewDonutData.totalNumberOfWeeksExcludingLeaveAndPublicHoliday, overViewDonutData.totalSessionsExcludingLeavesAndPublicHoliday, overViewLineChartData.lineChartExcludingLeaveAndPublicHolidaysCategoryDto, true, true, weekRange);
                } else {
                    //When no data exists
                    BuildChartForNoDataFound(overViewDonutData.overViewExcludingLeaveAndPublicHolidaysCatgories, overViewDonutData.totalNumberOfWeeksExcludingLeaveAndPublicHoliday, overViewLineChartData.lineChartExcludingLeaveAndPublicHolidaysCategoryDto, true, true, weekRange);
                }
            }
            //When leave exists 
            else if (event.value) {
                if (overViewDonutData.overViewExcludingLeaveCatgories.length > 0) {
                    setChartData(overViewDonutData.overViewExcludingLeaveCatgories, overViewDonutData.overViewExcludingLeaveSubCatgories, overViewDonutData.totalHoursExcludingLeaves, overViewDonutData.totalMinutesExcludingLeaves, overViewDonutData.totalNumberOfWeeksExcludingLeave, overViewDonutData.totalSessionsExcludingLeaves, overViewLineChartData.lineChartExcludinLeaveCategoryDto, false, true, weekRange)
                } else {
                    //When no data exists
                    BuildChartForNoDataFound(overViewDonutData.overViewExcludingLeaveCatgories, overViewDonutData.totalNumberOfWeeksExcludingLeave, overViewLineChartData.lineChartExcludinLeaveCategoryDto, false, true, weekRange);
                }
            }
            //When public holiday exists 
            else if (isExcludePublicHolidayToggelChecked) {
                if (overViewDonutData.overViewExcludingPublicHolidaysCatgories.length > 0) {
                    setChartData(overViewDonutData.overViewExcludingPublicHolidaysCatgories, overViewDonutData.overViewExcludingPublicHolidaysSubCatgories, overViewDonutData.totalHoursExcludingPublicHolidays, overViewDonutData.totalMinutesExcludingPublicHolidays, overViewDonutData.totalNumberOfWeeksExcludingPublicHoliday, overViewDonutData.totalSessionsExcludingPublicHolidays, overViewLineChartData.lineChartExcludinPublicHolidayCategoryDto, true, false, weekRange)
                } else {
                    //When no data exists
                    BuildChartForNoDataFound(overViewDonutData.overViewExcludingPublicHolidaysCatgories, overViewDonutData.totalNumberOfWeeksExcludingPublicHoliday, overViewLineChartData.lineChartExcludinPublicHolidayCategoryDto, true, false, weekRange);
                }
            } else {
                setAllData(overViewDonutData, overViewLineChartData.lineChartCategoryDto, false, false, weekRange);
            }
        }
    }

    // To hide the error messages when user clicks on white space
    const hideErrorMessagesForLeaveAndPublicHoliday = () => {
        setShowErrorMessageForLeaveToggle(false);
        setShowErrorMessageForPublicHolidayToggle(false);
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-lg-5 mb-2 p-0">
                        {
                            isPublicHolidayExistInPeriod && !isPublicHolidayExistsInAllWeeks &&
                            (
                                <div className="mb-1">
                                    <Switch size="small" defaultChecked={isPublicHolidayExistInPeriod} onLabel={""} offLabel={""} onChange={onExcludePublicHolidayChange} />
                                    <label className="form-check-label ms-2">Exclude weeks with public holidays</label>
                                </div>
                            )
                        }
                        {
                            !isPublicHolidayExistInPeriod && !isPublicHolidayExistsInAllWeeks &&
                            (
                                <div className="mb-1">
                                    <Switch size="small" onLabel={""} offLabel={""} disabled />
                                    <label className="form-check-label text-secondary ms-2">Exclude weeks with public holidays</label>
                                </div>
                            )
                        }
                        {
                            isPublicHolidayExistsInAllWeeks &&
                            (
                                <div className="mb-1">
                                    <Switch size="small" checked={!isPublicHolidayExistsInAllWeeks} onLabel={""} offLabel={""} onChange={onExcludePublicHolidayChange} />
                                    <label className="form-check-label ms-2">Exclude weeks with public holidays</label>
                                </div>
                            )
                        }
                        {showErrorMessageForPublicHolidayToggle && <span className="help-block mb-2 text-danger field-validation-valid">Public holidays occur in all weeks of the reporting period.</span>}
                        {
                            isLeaveExistInPeriod && !isLeaveExistsInAllWeeks &&
                            (
                                <div className="mb-0">
                                    <Switch size="small" defaultChecked={isLeaveExistInPeriod} onLabel={""} offLabel={""} onChange={onExcludeLeaveChange} />
                                    <label className="form-check-label ms-2">Exclude weeks with leave</label>
                                </div>
                            )
                        }
                        {
                            !isLeaveExistInPeriod && !isLeaveExistsInAllWeeks &&
                            (
                                <div className="mb-0">
                                    <Switch size="small" onLabel={""} offLabel={""} disabled />
                                    <label className="form-check-label text-secondary ms-2">Exclude weeks with leave</label>
                                </div>
                            )
                        }
                        {
                            isLeaveExistsInAllWeeks &&
                            (
                                <div className="mb-0">
                                    <Switch size="small" checked={!isLeaveExistsInAllWeeks} onLabel={""} offLabel={""} onChange={onExcludeLeaveChange} />
                                    <label className="form-check-label ms-2">Exclude weeks with leave</label>
                                </div>
                            )
                        }
                        {showErrorMessageForLeaveToggle && <span className="help-block m-b-none text-danger field-validation-valid">Leave occurs in all weeks of the reporting period.</span>}
                        <span className="text-muted mt-3 mb-0">Weeks showing : {totalNumberOfWeeks}</span>
                        {totalHours == 0 && totalMinutes == 0 && (<p>No activities in diary for this week.</p>)}
                    </div>
                    <div className="col-lg-5" onClick={hideErrorMessagesForLeaveAndPublicHoliday}></div>
                </div>
            </div>

            <div className="Container-fluid" onClick={hideErrorMessagesForLeaveAndPublicHoliday}>
                <div className="row">
                    <div className="col-lg-12">
                        <Chart transitions={false}>
                            <ChartTitle text="Total hours worked" position="top" align="left" />
                            <ChartXAxis>
                                <ChartXAxisItem
                                    title={{ text: "Weeks", position: "bottom" }}
                                    categories={weekRange}
                                    max={(totalNumberOfWeeks >= 8) ? (weekRange[weekRange.length - 1] + 0.5) : weekRange[weekRange.length - 1]}
                                />
                            </ChartXAxis>
                            <ChartSeries>
                                {
                                    lineChartCategories.map(mapSeries)
                                }
                            </ChartSeries>
                        </Chart>
                    </div>
                </div>
            </div>
            <div className="Container-fluid">
                <div className="row">
                    <div className="col-lg-6" onClick={reset}>

                        <Chart transitions={false} donutCenterRender={donutCenterRenderer} onSeriesClick={handleOnClick} onSeriesHover={handleOnHover}>
                            <ChartTooltip render={renderTooltip} background="#fff" />
                            <ChartLegend visible={false} />
                            <ChartArea background="none" />
                            <ChartSeries>
                                <ChartSeriesItem
                                    name="subCategories"
                                    width={500}
                                    type="donut"
                                    startAngle={0}
                                    field="totalDurationMinutes"
                                    categoryField="name"
                                    data={donutChartBySubCategories}
                                    colorField="color"
                                    size={40}
                                    holeSize={50}
                                    margin={3} >
                                </ChartSeriesItem>
                                <ChartSeriesItem
                                    name="categories"
                                    width={500}
                                    type="donut"
                                    startAngle={0}
                                    field="totalDurationMinutes"
                                    categoryField="name"
                                    data={donutChartByCategories}
                                    colorField="color"
                                    size={60}
                                    holeSize={50}
                                    margin={3} >
                                </ChartSeriesItem>
                            </ChartSeries>
                        </Chart>
                    </div>
                    <div className="col-lg-2" onClick={reset}>
                    </div>
                    <div className="col-lg-4 mt-5">
                        {donutChartByCategories && donutChartByCategories.map((category: any, index: any) => (
                            <Fragment key={index}>
                                <ExpansionPanel
                                    expandIcon="k-icon k-i-arrow-60-right"
                                    collapseIcon="k-icon k-i-arrow-60-down"
                                    style={{ border: 'none', borderBottom: "2px solid lightgrey" }}
                                    expanded={expanded[category.id]}
                                    tabIndex={0}
                                    key={category.id}
                                    onAction={onAction.bind(undefined, category.id)}
                                    title={
                                        <div className="row mt-2">
                                            <span className="mr-2">
                                                <svg width="50" height="50">
                                                    <circle cx="25" cy="25" r="25" fill={category.color} fillOpacity="0.3" />
                                                    <circle cx="25" cy="25" r="15" fill={category.color} fillOpacity="0.7" />
                                                    <circle cx="25" cy="25" r="5" fill={category.color} fillOpacity="1" />
                                                </svg>
                                                <label className="text-dark ps-2"><b>{category.name} - {category.totalHours?.toFixed(0)}h {category.totalMinutes?.toFixed(0)}m ({category?.percentage > 0 ? category?.percentage?.toFixed(1) : 0}%)</b></label>
                                            </span>
                                        </div>
                                    }
                                />
                                {donutChartBySubCategories.filter((x: any) => x.categoryId == category.id).map((subCategory: any, index: any) => (
                                    <Fragment key={index}>
                                        {expanded[category.id] && (
                                            <div className="container-fluid">
                                                <ExpansionPanelContent >
                                                    <div className="row mt-2">
                                                        <span className="col-1 ps-4 ms-1">
                                                            <svg width="20" height="20">
                                                                <circle cx="10" cy="10" r="10" fill={subCategory.color} />
                                                            </svg>
                                                        </span>
                                                        <label className="col-5 ps-4 ms-1 pe-0 text-break">{subCategory.name}</label>
                                                        <label className="col-5 ps-1 pe-0 text-break">{subCategory.totalHours?.toFixed(0)}h {subCategory.totalMinutes?.toFixed(0)}m ({subCategory?.percentage > 0 ? subCategory?.percentage?.toFixed(1) : 0}%)</label>
                                                    </div>
                                                </ExpansionPanelContent>
                                            </div>
                                        )}
                                    </Fragment>
                                ))}
                            </Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}